import { render, staticRenderFns } from "./PricingProposal.vue?vue&type=template&id=5c225ce4&"
import script from "./PricingProposal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PricingProposal.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports